import { makeStyles, styled } from '@material-ui/core/styles'
import Select from '@material-ui/core/Select'

export const PillSelect = styled(Select)(({ theme }) => ({
  height: theme.spacing(3),
  fontSize: '14px',
  marginRight: theme.spacing(1),
  marginTop: '0px',
  marginBottom: theme.spacing(2),
  '& label.Mui-focused': {
    color: theme.palette.primary.main,
  },
  '&.MuiOutlinedInput-root': {
    '& fieldset': {
      borderRadius: '16px',
      background: '#eee',
    },
    '& .MuiSelect-root': {
      zIndex: 1000,
      paddingRight: '40px',
      fontWeight: '700',
      maxWidth: '150px',
    },
    '& .MuiSelect-icon': {
      color: 'rgba(0, 0, 0, 0.54)',
      zIndex: 1000,
    },
    '& .MuiSelect-select:focus': {
      background: '#eee',
      borderRadius: '16px',
      padding: '3px 40px 3px 13px',
    },
    '& .MuiInputBase-input:focus': {
      outline: 'rgba(0, 0, 0, 0.23) solid 1px',
    },
  },
}))

export const useStyles = makeStyles(theme => ({
  scrollWrapper: {
    paddingTop: theme.spacing(2),
    [theme.breakpoints.down('1480')]: {
      paddingTop: theme.spacing(4),
      overflowX: 'scroll',
      '& .MuiBox-root': {
        width: '620px',
      },
    },
    [theme.breakpoints.between('sm', 'lg')]: {
      '&::-webkit-scrollbar': {
        height: '10px',
      },
      '&::-webkit-scrollbar-track': {
        background: '#F1F1F1',
      },
      '&::-webkit-scrollbar-thumb': {
        background: '#C1C1C1',
      },
    },
  },
}))
